import React from "react";
import PropTypes from 'prop-types';

export default function AccountSyncAlert({ message }) {
  return (
    <div className="alert alert-danger">
      <p>{message}</p>
    </div>
  );
}

AccountSyncAlert.propTypes = { message: PropTypes.string.isRequired };
